import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { style: {"width":"85vw"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_text_field_filled = _resolveComponent("v-text-field-filled")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_btn_next = _resolveComponent("v-btn-next")!
  const _component_v_btn_icon = _resolveComponent("v-btn-icon")!
  const _component_v_list_item_title = _resolveComponent("v-list-item-title")!
  const _component_v_list_item_subtitle = _resolveComponent("v-list-item-subtitle")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_ComputedIndicatorCreator = _resolveComponent("ComputedIndicatorCreator")!
  const _component_oss_dialog = _resolveComponent("oss-dialog")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    "grid-list-md": "",
    fluid: ""
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, { "no-gutters": "" }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            "d-flex": "",
            class: "font-weight-bold justify-center",
            style: {"white-space":"nowrap","overflow":"hidden","text-overflow":"ellipsis"}
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.displayExpressionTitle), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_v_row, {
        "no-gutters": "",
        class: "pb-2"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: _ctx._dontAllowCreation ? 12 : 11
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_text_field_filled, {
                modelValue: _ctx.searchBar,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchBar) = $event)),
                label: "Rechercher",
                "single-line": "",
                "hide-details": "",
                color: "primary",
                "data-cy": "choosePersonalisedCard-indicator-search",
                density: "compact",
                clearable: "",
                "append-inner-icon": "$search",
                "onClick:clear": _cache[1] || (_cache[1] = ($event: any) => (_ctx.searchBar = ''))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["cols"]),
          (!_ctx._dontAllowCreation)
            ? (_openBlock(), _createBlock(_component_v_col, {
                key: 0,
                cols: "1",
                class: "d-flex justify-center"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_btn, {
                    icon: "$add",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.openIB_GeneratorDialog = true)),
                    size: "small"
                  })
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_component_v_list, {
        subheader: "",
        lines: "two"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredComputedIndicators, (indicator, index) => {
            return (_openBlock(), _createBlock(_component_v_list_item, {
              key: index,
              class: "oss-list-item mb-2",
              disabled: indicator.alreadyConnected && _ctx.definedOperator === 'v1',
              onClick: ($event: any) => (_ctx.selection(indicator)),
              "data-cy": 'ChoosePersonalisedCard-' + index + '-TypeIndicateur'
            }, {
              append: _withCtx(() => [
                (_ctx.CINumberNeeded === 1)
                  ? (_openBlock(), _createBlock(_component_v_btn_next, { key: 0 }))
                  : (_openBlock(), _createBlock(_component_v_btn_icon, {
                      key: 1,
                      disabled: 
                            _ctx.selectedIndicatorsCompleted &&
                            _ctx.selectedIndicators.findIndex((e) => e && e.id === indicator.id) === -1
                        ,
                      "data-cy": "ChoosePersonalisedCard-TypeRatio-btn",
                      icon: 
                            _ctx.selectedIndicators.find((e) => e && e.id === indicator.id)
                                ? '$fa-check-square'
                                : '$fa-square'
                        
                    }, null, 8, ["disabled", "icon"]))
              ]),
              default: _withCtx(() => [
                _createVNode(_component_v_list_item_title, null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.displayIndicatorName(indicator.definition)), 1)
                  ]),
                  _: 2
                }, 1024),
                (indicator.alreadyConnected && _ctx.definedOperator === 'v1')
                  ? (_openBlock(), _createBlock(_component_v_list_item_subtitle, {
                      key: 0,
                      class: "font-italic"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" Cet indicateur est déjà affiché ")
                      ])),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1032, ["disabled", "onClick", "data-cy"]))
          }), 128))
        ]),
        _: 1
      }),
      _createVNode(_component_oss_dialog, {
        modelValue: _ctx.openIB_GeneratorDialog,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.openIB_GeneratorDialog) = $event)),
        title: "Créer un nouvel indicateur",
        actions: _ctx.CI_creatorActions
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_ComputedIndicatorCreator, {
              companyId: _ctx.companyId,
              actions: _ctx.CI_creatorActions,
              onComputedIndicatorSavedInBDD: _cache[3] || (_cache[3] = ($event: any) => (_ctx.CI_created($event)))
            }, null, 8, ["companyId", "actions"])
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "actions"])
    ]),
    _: 1
  }))
}